module.exports = "/lucky-balls/img/drum/drum_loop_013.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/drum/drum_loop_013.png
// module id = 1028
// module chunks = 0